import React from "react";
import { Lock } from "lucide-react";

/**
 * ComingSoonSection — polished placeholder for phases 2/3.
 * Same aesthetic as ready sections; hints at what will land.
 */
export default function ComingSoonSection({ section }) {
  const Icon = section.icon;
  return (
    <div className="max-w-2xl" data-testid={`section-coming-soon-${section.slug}`}>
      <div className="term-card p-10 text-center">
        <div
          className="w-14 h-14 mx-auto rounded-full grid place-items-center mb-4"
          style={{ background: `var(--sc-${section.color})15`, border: `1px solid var(--sc-${section.color})55` }}
        >
          <Icon className="w-6 h-6" style={{ color: `var(--sc-${section.color})` }} />
        </div>
        <div className="sc-label mb-2" style={{ color: `var(--sc-${section.color})` }}>◈ COMING SOON</div>
        <h2 className="sc-heading text-2xl font-black mb-2">{section.label}</h2>
        <p className="text-sm text-zinc-400 max-w-md mx-auto">{section.desc}</p>
        <div className="mt-6 inline-flex items-center gap-2 text-[10px] sc-mono text-zinc-500">
          <Lock className="w-3 h-3" />
          On the roadmap · check back after launch
        </div>
      </div>
    </div>
  );
}
